"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getJSONString = exports.arrayRemove = exports.isNullOrUndefined = exports.firstUpperCase = exports.isPrimitive = void 0;
function isPrimitive(value) {
    const type = typeof value;
    // eslint-disable-next-line eqeqeq
    return value == null || (type !== 'object' && type !== 'function');
}
exports.isPrimitive = isPrimitive;
function firstUpperCase(str) {
    return str.replace(/\b(\w)(\w*)/g, ($0, $1, $2) => $1.toUpperCase() + $2.toLowerCase());
}
exports.firstUpperCase = firstUpperCase;
function isNullOrUndefined(v) {
    return v === null || v === undefined;
}
exports.isNullOrUndefined = isNullOrUndefined;
/**
 *  lodash的remove无法触发vue更新 额外写个
 * @param array
 * @param fn
 * @returns
 */
function arrayRemove(array, fn) {
    if (!Array.isArray(array)) {
        return [];
    }
    const removed = [];
    const len = array.length;
    let index = len - 1;
    while (index > -1) {
        if (fn(array[index])) {
            removed.push(...array.splice(index, 1));
        }
        index -= 1;
    }
    return removed;
}
exports.arrayRemove = arrayRemove;
function getJSONString(obj) {
    try {
        return JSON.stringify(obj, undefined, '\t');
    }
    catch (error) {
        console.error('getJSONString fail:', error);
        return '';
    }
}
exports.getJSONString = getJSONString;
//# sourceMappingURL=lang.js.map